import { useGetCountryAnalyticsApiV1Suspense } from "@/api/__generated__/api.schema";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";
import { CountryFlag } from "@/routes/custom-music/dsp-analytics/components/graphics/country-flag";
import { RevenueBreakdownTable } from "@/routes/custom-music/dsp-analytics/components/graphics/revenue-breakdown-table";
import { RevenueChart } from "@/routes/custom-music/dsp-analytics/components/graphics/revenue-chart";
import { useAnalyticsMonth } from "@/routes/custom-music/dsp-analytics/context/dsp-analytics-context";
import { getPreviousMonthRange } from "@/utils/date";
import { formatMonthString } from "@/utils/time";
import { useState } from "react";

export const CountryAnalytics = () => {
  const { selectedMonthRange } = useAnalyticsMonth();
  const workspaceId = useWorkspaceId();
  const {
    data: {
      data: { items: countryAnalytics },
    },
  } = useGetCountryAnalyticsApiV1Suspense(workspaceId, {
    from: formatMonthString(selectedMonthRange[0]),
    to: formatMonthString(selectedMonthRange[1]),
  });
  // previous revenue with the same length as the current revenue
  const {
    data: {
      data: { items: previousCountryAnalytics },
    },
  } = useGetCountryAnalyticsApiV1Suspense(workspaceId, {
    from: formatMonthString(getPreviousMonthRange(selectedMonthRange)[0]),
    to: formatMonthString(getPreviousMonthRange(selectedMonthRange)[1]),
  });

  const [selectedIds, setSelectedIds] = useState<string[]>(() => countryAnalytics.slice(0, 5).map((item) => item.name));
  return (
    <div className="flex flex-col gap-6">
      <RevenueChart
        analytics={countryAnalytics}
        previousAnalytics={previousCountryAnalytics}
        selectedIds={selectedIds}
      />
      <RevenueBreakdownTable
        title="Country"
        analytics={countryAnalytics}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        additionalColumns={[
          {
            label: "Platform",
            render: (item) => <CountryFlag countryCode={item.name} />,
            position: "start",
          },
        ]}
      />
    </div>
  );
};
